// Domain used when setting/removing auth + session cookies.
// LOCAL development runs on localhost. Deployed environments share cookies
// across subdomains (e.g. app + app-v3) via a wildcard domain. COOKIE_DOMAIN
// lets the dev environment (app.teambuildr.dev / app-v3.teambuildr.dev)
// override the default .teambuildr.com used by staging/production.
const cookieDomain = process.env.ENVIRONMENT === 'LOCAL'
  ? 'localhost'
  : (process.env.COOKIE_DOMAIN || '.teambuildr.com');

export default cookieDomain;
